import Immutable, { fromJS } from 'immutable';
import { VIEW_GET_LOADED } from '../../../actions/Entity/View';
var initialState = fromJS({});
export default function view() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case VIEW_GET_LOADED:
      {
        if (action.action === 'replace') {
          return state.setIn([action.viewId, action.displayId], fromJS(action.data));
        } else if (action.action === 'append') {
          var immutableData = fromJS(action.data);
          var originalEntities = state.getIn([action.viewId, action.displayId, 'entities'], Immutable.List());
          var appendedEntities = originalEntities.merge(immutableData.get('entities', Immutable.List()));
          return state.setIn([action.viewId, action.displayId], immutableData.set('entities', appendedEntities));
        }
        return state;
      }
    default:
      return state;
  }
}